export const FallbackMessages = {
  therapist: {
    title: 'Unable to Load Your Productivity & Labor Metrics',
    message: 'We’re sorry — something went wrong while loading your productivity & labor metrics.',
  },
  dor: {
    title: 'Unable to Load Department Metrics',
    message: 'We’re sorry — something went wrong while loading your department metrics.',
  },
  mds: {
    title: 'Unable to Load MDS Metrics',
    message: 'We’re sorry — something went wrong while loading your MDS metrics.',
  },
};
